import { h } from "preact";

const statusToClass = {
    "wrong": "danger",
    "partial": "warning",
    "correct": "success"
}

const statusToIconClass = {
    "wrong": "glyphicon-remove text-danger",
    "partial": "glyphicon-minus text-warning",
    "correct": "glyphicon-ok text-success"
}

/**
 * 
 * @param {{
 *   rubricReport: import("../../shared-types").RubricReport,
 * }} props 
 */
export default function (props) {
    let rubricReport = props.rubricReport;

    return <table class="table table-bordered table-condensed" style="height:1px;">
        <thead>
            <tr>
                <th class="info">&nbsp;</th>
                {
                    rubricReport.elements[0].scales.map((scale) => {
                        return <th class="text-center info">
                            <div>{scale.name}</div>
                        </th>
                    })
                }
            </tr>
        </thead>
        <tbody>
            {
                rubricReport.elements.map((element) => {
                    return <>
                        <tr>
                            <td class="active" rowSpan={element.feedback ? 2 : 1}>
                                <div style="font-weight:bold;">{element.name}</div>
                                <div dangerouslySetInnerHTML={{ __html: element.description }}></div>
                            </td>
                            {
                                element.scales.map((scale) => {
                                    return <td class={statusToClass[scale.status]}>
                                        <span class={`glyphicon pull-right ${statusToIconClass[scale.status]}`}
                                            style={scale.status == 'none' ? "display:none;" : ""}></span>
                                        <div style="display:flex;flex-direction:column;justify-content:space-between;height:100%;min-height:100%;">
                                            <div dangerouslySetInnerHTML={{ __html: scale.description }}></div>
                                            <div style="align-self:flex-end;text-align:center;width:100%;font-weight:bold;">{scale.score}</div>
                                        </div>
                                    </td>
                                })
                            }
                        </tr>
                        {element.feedback ? <tr>
                            <td colSpan={element.scales.length}>
                                <span style="font-weight: bold">Teacher Feedback:&nbsp;</span><span dangerouslySetInnerHTML={{ __html: element.feedback }}></span>
                            </td>
                        </tr> : null}
                    </>
                })
            }
        </tbody>
    </table>
}